import { loadSentry } from './lazySentry';
export const initErrorHandling = async ({ dsn, consentGiven, release }) => {
    const { browserTracingIntegration, getClient, getReplay, init, replayIntegration } = await loadSentry();
    void getReplay()?.stop();
    void getClient()?.close(0);
    init({
        dsn,
        release,
        enabled: !!consentGiven && Boolean(dsn?.trim()),
        integrations: consentGiven ? [browserTracingIntegration(), replayIntegration()] : [],
        tracesSampleRate: 0.2,
        replaysSessionSampleRate: 0.0,
        replaysOnErrorSampleRate: 1.0,
        ignoreErrors: ['Object Not Found Matching Id'],
    });
};
